import React, { useId } from "react";
import PropTypes from "prop-types";

const CalendarCloseIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  selected,
  ...props
}) => {
  const id = useId().replace(/:/g, "");
  const clipId = `calendar-close-clip-${id}`;
  const strokeColor =
    stroke && stroke !== "currentColor" ? stroke : color || "#31237D";

  return (
    <svg
      width={width || 51}
      height={height || 51}
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={selected ? 1 : undefined}
      className={className}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M18.2795 4.83148L17.8608 12.8198"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "3.99964"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.256 5.66876L33.8374 13.6571"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "3.99964"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.0896 28.1599L43.8223 14.1804C43.9378 11.976 42.2419 10.0924 40.0374 9.97691L12.0783 8.51163C9.87389 8.3961 7.99037 10.092 7.87484 12.2965L6.40957 40.2556C6.29404 42.46 7.98996 44.3435 10.1944 44.4591L26.171 45.2964"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "3.99964"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.45624 20.2848L43.4037 22.1687"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "3.99964"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.1595 45.715L44.6682 36.2529"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "3.99964"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.6828 35.7296L44.1449 46.2383"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "3.99964"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect
            width="47.9957"
            height="47.9957"
            fill="white"
            transform="translate(2.5119) rotate(3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

CalendarCloseIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selected: PropTypes.bool,
};

CalendarCloseIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
  selected: false,
};

export default CalendarCloseIcon;
